var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDressShirt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.965,
    height: 27.965,
    viewBox: "0 0 27.965 27.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#211c51}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_045---Shirt",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M27.033 20.973v-5.406a6.418 6.418 0 0 0-.466-2.33L23.5 5.789a4.311 4.311 0 0 0-2.33-2.4c-.769-.312-1.445-.555-2.055-.736 0-.163.061 0-1.286-2.1A1.175 1.175 0 0 0 16.825 0h-5.686a1.175 1.175 0 0 0-.988.545c-1.333 2.079-1.268 1.939-1.3 2.1a21.594 21.594 0 0 0-2.051.743 4.279 4.279 0 0 0-2.33 2.391L1.4 13.223a6.423 6.423 0 0 0-.466 2.33v5.421a.932.932 0 0 0-.934.932v1.864a.932.932 0 0 0 .932.932h4.195a.932.932 0 0 0 .932-.932v-1.864a.932.932 0 0 0-.508-.825v-3.5a5.56 5.56 0 0 1 .564-2.428l.932-1.58-.522 12.555a.466.466 0 0 0 .247.429c1.92 1.011 3.948 1.408 7.21 1.408s5.29-.4 7.21-1.4a.466.466 0 0 0 .247-.429l-.522-12.566.932 1.547a5.565 5.565 0 0 1 .583 2.461v3.5a.932.932 0 0 0-.527.825v1.867a.932.932 0 0 0 .932.932h4.195a.932.932 0 0 0 .932-.932v-1.864a.932.932 0 0 0-.932-.932zM10.934 1.049a.242.242 0 0 1 .205-.117h5.686a.242.242 0 0 1 .205.117C18.284 3 18.177 2.8 18.144 2.862a3.607 3.607 0 0 1-2.069 2.615 4.484 4.484 0 0 0-1.03-1.156 2.922 2.922 0 0 0 1.734-1.883.466.466 0 0 0-.8-.41 12.607 12.607 0 0 0-3.971 0 .466.466 0 0 0-.825.41A2.922 2.922 0 0 0 12.91 4.33a4.484 4.484 0 0 0-1.03 1.156 3.607 3.607 0 0 1-2.069-2.624c-.023-.065-.121.131 1.123-1.813zm3.048 2.68a3.263 3.263 0 0 1-1.5-.811 11.9 11.9 0 0 1 2.992 0 3.2 3.2 0 0 1-1.492.811zM5.127 23.77H.932v-1.864h4.153c.042 0 .042-.206.042 1.864zM7.192 11.5l-1.9 3.207a6.525 6.525 0 0 0-.676 2.871v3.393H1.864c0-5.709-.121-6.134.373-7.406l3.09-7.455a3.342 3.342 0 0 1 1.837-1.864c.7-.289 1.324-.517 1.864-.685a4.386 4.386 0 0 0 2.96 2.964.466.466 0 0 0 .564-.28 3.374 3.374 0 0 1 .965-1.189v21.977a13.247 13.247 0 0 1-6.059-1.161l.587-14.108a.466.466 0 0 0-.853-.261zm13.582 0a.466.466 0 0 0-.867.256l.6 14.108a13.158 13.158 0 0 1-6.059 1.161V5.052a3.342 3.342 0 0 1 .965 1.175.466.466 0 0 0 .564.28 4.386 4.386 0 0 0 2.941-2.941 18.642 18.642 0 0 1 1.864.685 3.351 3.351 0 0 1 1.841 1.864L25.7 13.54a5.509 5.509 0 0 1 .4 2.027v5.407h-2.754V17.58a6.525 6.525 0 0 0-.694-2.9zm2.064 12.27c0-2.065 0-1.864.042-1.864h4.153v1.864z",
    className: "cls-1",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 0.471,
    cy: 0.445,
    className: "cls-1",
    rx: 0.471,
    ry: 0.445,
    transform: "translate(12.133 7.949)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 0.471,
    cy: 0.471,
    r: 0.471,
    className: "cls-1",
    transform: "translate(12.133 11.662)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    cx: 0.471,
    cy: 0.471,
    r: 0.471,
    className: "cls-1",
    transform: "translate(12.133 15.375)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    cx: 0.471,
    cy: 0.471,
    r: 0.471,
    className: "cls-1",
    transform: "translate(12.133 19.089)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    cx: 0.471,
    cy: 0.471,
    r: 0.471,
    className: "cls-1",
    transform: "translate(12.133 22.854)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    d: "M36.263 21h-2.8a.466.466 0 0 0 0 .932h2.8a.466.466 0 1 0 0-.932z",
    className: "cls-1",
    transform: "translate(-17.619 -11.212)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDressShirt);
export default __webpack_public_path__ + "static/media/dress-shirt.1392e282.svg";
export { ForwardRef as ReactComponent };